import React from 'react';
import { Box, Stack, Typography } from '@mui/material';

const ExerciseVideos = ({ exerciseVideos, name }) => {
  if (!exerciseVideos.length) return 'Loading...';
  return (
    <>
      <Box
        justifyContent="center"
        alignItems="center"
        sx={{ marginTop: { lg: '200px', xs: '20px' } }}
        p="20px"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1440 320"
          className="svg"
        >
          <path
            fill="#fed136"
            fillOpacity="1"
            d="M0,32L12.6,64C25.3,96,51,160,76,202.7C101.1,245,126,267,152,272C176.8,277,202,267,227,250.7C252.6,235,278,213,303,213.3C328.4,213,354,235,379,218.7C404.2,203,429,149,455,122.7C480,96,505,96,531,85.3C555.8,75,581,53,606,64C631.6,75,657,117,682,117.3C707.4,117,733,75,758,85.3C783.2,96,808,160,834,176C858.9,192,884,160,909,133.3C934.7,107,960,85,985,69.3C1010.5,53,1036,43,1061,53.3C1086.3,64,1112,96,1137,138.7C1162.1,181,1187,235,1213,218.7C1237.9,203,1263,117,1288,80C1313.7,43,1339,53,1364,69.3C1389.5,85,1415,107,1427,117.3L1440,128L1440,320L1427.4,320C1414.7,320,1389,320,1364,320C1338.9,320,1314,320,1288,320C1263.2,320,1238,320,1213,320C1187.4,320,1162,320,1137,320C1111.6,320,1086,320,1061,320C1035.8,320,1011,320,985,320C960,320,935,320,909,320C884.2,320,859,320,834,320C808.4,320,783,320,758,320C732.6,320,707,320,682,320C656.8,320,632,320,606,320C581.1,320,556,320,531,320C505.3,320,480,320,455,320C429.5,320,404,320,379,320C353.7,320,328,320,303,320C277.9,320,253,320,227,320C202.1,320,177,320,152,320C126.3,320,101,320,76,320C50.5,320,25,320,13,320L0,320Z"
          ></path>
        </svg>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
          <path
            fill="#fed136"
            fillOpacity="1"
            d="M0,32L12.6,64C25.3,96,51,160,76,202.7C101.1,245,126,267,152,272C176.8,277,202,267,227,250.7C252.6,235,278,213,303,213.3C328.4,213,354,235,379,218.7C404.2,203,429,149,455,122.7C480,96,505,96,531,85.3C555.8,75,581,53,606,64C631.6,75,657,117,682,117.3C707.4,117,733,75,758,85.3C783.2,96,808,160,834,176C858.9,192,884,160,909,133.3C934.7,107,960,85,985,69.3C1010.5,53,1036,43,1061,53.3C1086.3,64,1112,96,1137,138.7C1162.1,181,1187,235,1213,218.7C1237.9,203,1263,117,1288,80C1313.7,43,1339,53,1364,69.3C1389.5,85,1415,107,1427,117.3L1440,128L1440,0L1427.4,0C1414.7,0,1389,0,1364,0C1338.9,0,1314,0,1288,0C1263.2,0,1238,0,1213,0C1187.4,0,1162,0,1137,0C1111.6,0,1086,0,1061,0C1035.8,0,1011,0,985,0C960,0,935,0,909,0C884.2,0,859,0,834,0C808.4,0,783,0,758,0C732.6,0,707,0,682,0C656.8,0,632,0,606,0C581.1,0,556,0,531,0C505.3,0,480,0,455,0C429.5,0,404,0,379,0C353.7,0,328,0,303,0C277.9,0,253,0,227,0C202.1,0,177,0,152,0C126.3,0,101,0,76,0C50.5,0,25,0,13,0L0,0Z"
          ></path>
        </svg>
        <Typography
          variant="h3"
          mb="10px"
          texttransform="capitalize"
          className="titleVideo"
        >
          Watch {name} <br />
        </Typography>
        <Typography
          variant="h3"
          mb="-100px"
          texttransform="capitalize"
          className="titleVideo"
        >
          - exercise videos -
        </Typography>

        <Stack
          mt="200px"
          justifyContent="center"
          flexWrap="wrap"
          alignItems="center"
          sx={{
            flexDirection: { lg: 'row' },
            gap: { lg: '30px', xs: '0' },
          }}
        >
          {exerciseVideos?.slice(0, 6).map((item, index) => (
            <a
              key={index}
              className="exercise-video"
              href={`https://www.youtube.com/watch?v=${item.video.videoId}`}
              target="_blank"
              rel="noreferrer"
            >
              <img src={item.video.thumbnails[0].url} alt={item.video.title} />

              <Box>
                <Typography variant="h6" color="#ff2625">
                  {item.video.title}
                </Typography>
                <Typography variant="h6" color="#fff">
                  {item.video.channelName}
                </Typography>
              </Box>
            </a>
          ))}
        </Stack>
      </Box>
    </>
  );
};

export default ExerciseVideos;
